import * as React from "react";

export const DoughnutIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.5} clipPath="url(#a)" fill="currentColor">
      <path d="M10.885 0A10.88 10.88 0 0 0 0 10.885c0 .324.263.587.586.587h10.3a.587.587 0 0 0 .586-.587V.586A.587.587 0 0 0 10.885 0M6.712 13.168a.59.59 0 0 0-.514-.305H2.729a.586.586 0 0 0-.56.762C3.275 17.144 6.46 19.76 10.299 20v-4.396a4.76 4.76 0 0 1-3.586-2.436m6.912-10.997a.587.587 0 0 0-.762.56v3.468c0 .215.117.412.305.515a4.76 4.76 0 0 1 2.436 3.586h4.397c-.242-3.846-2.866-7.027-6.376-8.129m1.98 9.302a4.765 4.765 0 0 1-4.132 4.132V20A9.13 9.13 0 0 0 20 11.473z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
